import dayjs from 'dayjs';
import { PincodeData } from 'src';
import { getPersonAttributes, leadAttributes, getVehicleAttributes, dealerAttributes, orderAttributes } from '.';

export const checkIfIsTestPincode = (pincode: string) => pincode.startsWith('PINCODE');


export const getTestPincode = (pincode: string): PincodeData => {

  const noPermite = pincode.includes('NOPERMITE') || pincode.includes('NO-PERMITE');
  const isElectrico = pincode.includes('ID');

  const content = [];
  if (pincode.includes('PERSON'))  {
    content.push({
      attributes: [...getPersonAttributes(noPermite)]
    });
  }
  if (pincode.includes('LEAD'))  {
    content.push({
      attributes: [...leadAttributes]
    });
  }
  if (pincode.includes('VEHICLE'))  {
    content.push({
      attributes: [...getVehicleAttributes(isElectrico)]
    });
  }
  if (pincode.includes('ORDER'))  {
    content.push({
      attributes: [...orderAttributes]
    });
  }
  if (pincode.includes('DEALER'))  {
    content.push({
      attributes: [...dealerAttributes]
    });
  }

  return {
    status: {
      result: 'success',
      timestamp: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      code: 1,
      time: 0.5742380619049072,
    },
    params: {
      pincode: pincode,
      token: 'VW_DDB_FORM_TEST',
    },
    content: content,
  };
}
